<template>
  <div>
  <facit-header ref="facitHeader"></facit-header>
  <div class="main-div">
    <b-card-group deck class="mb-3" v-if=!changeDashboard>
      <b-card class="text-center card-background"
      @mouseover="activeLink='sale'"
      @mouseleave="activeLink=null">
          <a
            @click="sale()"
            class="link-decoration link-color-settings flex-container"
            :class="{'link-color-menu': activeLink === 'sale'}">
          <div class="mt-30"> <v-icon name="package" base-class="icon-width"></v-icon> </div>
          <div class="mt-3"> Sales and Marketing</div>
        </a>
      </b-card>
      <b-card class="text-center card-background "
      @mouseover="activeLink='videos'"
      @mouseleave="activeLink=null"">
      <a
        @click="videos()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'videos'}">
        <div class="mt-30"> <v-icon name="film" base-class="icon-width"></v-icon> </div>
        <div class="mt-3"> Videos</div>
    </a>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='downloads'"
      @mouseleave="activeLink=null">
        <a @click="downloads()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'downloads'}">
          <div class="mt-30"> <v-icon name="file" base-class="icon-width"></v-icon> </div>
          <div class="mt-3"> Downloads</div>
        </a>
      </b-card>
    </b-card-group>
    <b-card-group deck class="mb-3" v-if=!changeDashboard>
      <b-card class="text-center card-background"
      @mouseover="activeLink='architecture'"
      @mouseleave="activeLink=null">
        <a @click="architecture()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'architecture'}">
        <div class="flex-container">
          <div class="mt-30"> <v-icon name="cpu" base-class="icon-width"></v-icon> </div>
          <div class = "mt-3" > Architecture</div>
        </div>
      </a>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='hardwareCalculator'"
      @mouseleave="activeLink=null">
        <a @click="hardwareCalculator()" class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'hardwareCalculator'}">
        <div class="mt-30"> <v-icon name="server" base-class="icon-width"></v-icon> </div>
        <div class = "mt-3" > Hardware Calculator</div>
      </a>
      </b-card>
      <b-card
      class="text-center card-background"
      @mouseover="activeLink='demo'"
      @mouseleave="activeLink=null">
        <div class="flex-container">
          <a
          @click=""
          class="link-decoration link-color-settings flex-container"
          :class="{'link-color-menu': activeLink === 'demo'}">
          <div class="mt-30"> <a href = "https://server.facitdatasystems.com" target = "_blank"> <v-icon name="youtube" base-class="icon-width"></v-icon> </a> </div>
          <div class = "mt-3" > <a href = "https://server.facitdatasystems.com" target = "_blank"> Live Demo </a></div>
          <div class="mt-3"> Username: demo@facitdatasystems.com  <br> Password: Facittopsecret &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
        </a>
      </div>
      </b-card>
    </b-card-group>
    <b-card-group deck class="mb-3" v-if=!changeDashboard>
      <b-card class="text-center card-background"
      @mouseover="activeLink='profile'"
      @mouseleave="activeLink=null">
        <a @click="identityCloak()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'profile'}">
        <div class="flex-container">
          <div class="mt-11"> <img v-if="activeLink === 'profile'" src="../assets/img/cloak-active.png"/> <img v-else src="../assets/img/cloak.png"/> </div>
          <div class = "mt-3" > Identity Cloak</div>
        </div>
      </a>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='support'"
      @mouseleave="activeLink=null">
        <a @click="support()" class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'support'}">
        <div class="mt-30"> <v-icon name="phone" base-class="icon-width"></v-icon> </div>
        <div class = "mt-3" > Support</div>
      </a>
      </b-card>
      <b-card
      class="text-center card-background"
      @mouseover="activeLink='licence'"
      @mouseleave="activeLink=null">
        <div class="flex-container">
          <a
          @click="licence()"
          class="link-decoration link-color-settings flex-container"
          :class="{'link-color-menu': activeLink === 'licence'}">
          <div class="mt-30"> <v-icon name="file-text" base-class="icon-width"></v-icon> </div>
          <div class = "mt-3" > Demo License </div>
        </a>
      </div>
      </b-card>
    </b-card-group>
    <b-card-group deck class="mb-3" v-if=changeDashboard>
      <b-card class="text-center card-background"
      @mouseover="activeLink='downloads'"
      @mouseleave="activeLink=null">
        <a @click="downloads()"
        class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'downloads'}">
          <div class="mt-30"> <v-icon name="file" base-class="icon-width"></v-icon> </div>
          <div class="mt-3"> Downloads</div>
        </a>
      </b-card>
      <b-card
      class="text-center card-background"
      @mouseover="activeLink='licence'"
      @mouseleave="activeLink=null">
        <div class="flex-container">
          <a
          @click="licence()"
          class="link-decoration link-color-settings flex-container"
          :class="{'link-color-menu': activeLink === 'licence'}">
          <div class="mt-30"> <v-icon name="file-text" base-class="icon-width"></v-icon> </div>
          <div class = "mt-3" > License </div>
        </a>
      </div>
      </b-card>
      <b-card class="text-center card-background"
      @mouseover="activeLink='support'"
      @mouseleave="activeLink=null">
        <a @click="support()" class="link-decoration link-color-settings flex-container"
        :class="{'link-color-menu': activeLink === 'support'}">
        <div class="mt-30"> <v-icon name="phone" base-class="icon-width"></v-icon> </div>
        <div class = "mt-3" > Support</div>
      </a>
      </b-card>
    </b-card-group>
</div>
</div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';

export default {
  name: 'Dashboard',
  components: { FacitHeader },
  data() {
    return {
      credit: null,
      activeLink: null,
      AccountDetail: null,
      changeDashboard: false,
    };
  },
  created() {
    let emailAddress = Session.getAccessToken().user.email
    emailAddress = emailAddress.toLowerCase()
    if (emailAddress === 'manfred.derr@simplysol.de' || emailAddress === 'asadriaz.shah@outlook.com' || emailAddress === 'g.fierro@es-sicherheit.ch') {
      this.changeDashboard = true
    }
    this.getAccount();
    this.$eventHub.$on('credit-updated', this.getAccount);
  },
  beforeDestroy() {
    this.$eventHub.$off('credit-updated');
  },
  methods: {
    async getAccount() {
      const token = Session.getAccessToken();
      const userId = token.user.id;
      this.AccountDetail = await API.get(`Accounts/${userId}/`, { cache: false });
      Session.updateUser(this.AccountDetail);
    },
    downloads() {
      this.$router.push('downloads');
    },
    demo() {
      window.location = 'https://server.facitdatasystems.com';
    },
    videos() {
      this.$router.push('videos');
    },
    sale() {
      this.$router.push('sale');
    },
    architecture() {
      this.$router.push('architecture');
    },
    hardwareCalculator() {
      this.$router.push('hardwareCalculator');
    },
    support() {
      this.$router.push('support');
    },
    profile() {
      this.$router.push('profile');
    },
    identityCloak() {
      this.$router.push('identityCloak');
    },
    licence() {
      let emailAddress = Session.getAccessToken().user.email
      emailAddress = emailAddress.toLowerCase()
      if (emailAddress === 'me.asadshah@gmail.com') {
        this.$router.push('licenceAll');
      } else {
        this.$router.push('licence');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mt-30 {
  margin-top: 30px;
}

.mt-11 {
  margin-top: 11px;
}

.main-div {
  width: 80%;
  margin: 30px auto;
}
.card-background {
  background-color: #DCDCDC;
  height: 225px;
  text-align: center;
  border: 1px solid #eee;
}

.icon-width {
  width: 40px !important;
  height: 40px !important;
}
.buy-credits-button {
  float: left;
}

.flex-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.icon-div {
  margin-top: 30px;
}

.link-decoration {
  text-decoration: none;
  cursor: pointer;
}

a {
  color: #2c3e50 !important
}

a:hover {
  color: #2c3e50 !important;
  text-decoration: none;
}

.link-color-settings {
  color: #2c3e50 !important;
}

.link-color {
  color: #90a4ae !important;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.link-color-hover {
  color: #fff;
}
.link-color-menu {
  color: #9da7b2 !important;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue